import { hrBaseApi } from "app/services/HrBaseApi";

export const employeeDashboardApi = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Monthwise Attendance
    getMonthwiseCheckinList: builder.query({
      query: ({ partnerId, employeeId, year, month }) => ({
        url: `/Felix/Monthwisecheckinlist/?Partner_Id=${partnerId}&Employee_Id=${employeeId}&Year=${year}&Month=${month}`,
        method: "GET",
      }),
    }),

    // Leave Balance
    getEmployeeLeaveBalance: builder.query({
      query: ({ companyId, employeeId, year }) => ({
        url: `/Felix/GetEmployeeLeaveBalance/?Company_Id=${companyId}&Employee_Id=${employeeId}&Year=${year}`,
        method: "GET",
      }),
    }),

    // Monthly Timesheet
    getTimesheetForMonthly: builder.query({
      query: ({ partnerId, employeeId, month, year }) => ({
        url: `/Felix/TimesheetForMonthly/?Partner_Id=${partnerId}&Employee_Id=${employeeId}&Month=${month}&Year=${year}`,
        method: "GET",
      }),
    }),

    // Holiday List
    getHolidayYearwiseList: builder.query({
      query: ({ partnerId, year }) => ({
        url: `/Felix/holidayyearwiselist/?Partner_Id=${partnerId}&Year=${year}`,
        method: "GET",
      }),
    }),

  }),
});

export const {
  useGetMonthwiseCheckinListQuery,
  useLazyGetMonthwiseCheckinListQuery,

  useGetEmployeeLeaveBalanceQuery,
  useLazyGetEmployeeLeaveBalanceQuery,

  useGetTimesheetForMonthlyQuery,
  useLazyGetTimesheetForMonthlyQuery,

  useGetHolidayYearwiseListQuery,
  useLazyGetHolidayYearwiseListQuery,

} = employeeDashboardApi;